module.exports = __webpack_public_path__ + "ee9affb806c1ea237edf335fd8318bc5.png";